export default __webpack_public_path__ + "static/media/Google_Cloud_for_Statups_logo.64661f4a.png";